import { Injector, NgModule } from '@angular/core';
import { TranslService } from './transl.service';
import { TranslDirective } from './transl.directive';
import { TranslLocale } from './transl-locale.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
    declarations: [TranslDirective, TranslLocale],
    imports: [TranslocoModule],
    exports: [TranslDirective, TranslLocale, TranslocoModule],
    providers: [TranslDirective, TranslService],
})
export class TranslModule {
    static injector: Injector;

    constructor(injector: Injector) {
        TranslModule.injector = injector;
    }
}
